import arrhythmiaDisease from './arrhythmiaDisease';
import generalChronicDisease from './generalChronicDisease';

/**
 * Add a disease by exporting the same shape as arrhythmiaDisease
 * (id, label, title, summary, createEmpty, derive, sections) and listing it here.
 * CCM can hold one plan per disease. PCM holds one disease plan.
 */
export const DISEASE_PLANS = [arrhythmiaDisease, generalChronicDisease];

export function getDisease(id) {
  return DISEASE_PLANS.find((disease) => disease.id === id) || null;
}

export function listDiseases() {
  return DISEASE_PLANS.map((disease) => ({
    id: disease.id,
    label: disease.label,
    title: disease.title,
    summary: disease.summary,
  }));
}
